import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'translate',
  standalone: false,
})
export class TranslatePipe implements PipeTransform {
  transform(
    value: Record<string, string>,
    lang: string,
    fallbackValue = '',
  ): string {
    if (lang !== 'sv' && value) {
      const translation = value[lang];
      // eslint-disable-next-line unicorn/prefer-logical-operator-over-ternary
      return translation ? translation : fallbackValue;
    }
    return fallbackValue;
  }
}
